import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';
import Image from 'react-bootstrap/Image';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { useSelector } from 'react-redux';
import { pintaFecha, pintaNumero, pintaPesos, pintaEstado } from '../../libreria/utilidades';
import './NotaCobro.css';

function NotaCobro() {
  const notacobro = useSelector((store) => store.notacobro);
  const comunidad = useSelector((store) => store.comunidad);
  const comunidadIconos = useSelector((store) => store.comunidadIconos);

  return (
    <Card className='NotaCobro shadow-sm'>
      <Card.Body>
        <Table size='sm' responsive borderless className='h6 mb-2'>
          <tbody>
            <tr>
              <td rowSpan='3' className='text-center align-middle'>
                NOTA DE COBRO
              </td>
              <th className='text-center'>{comunidad.selected.emisor_razon_social}</th>
              <th className='text-center text-primary'>NOTA COBRO</th>
            </tr>
            <tr>
              <th className='text-center'>{comunidad.selected.emisor_giro}</th>
              <th className='text-center text-primary'>Nº: {notacobro.folio}</th>
            </tr>
            <tr>
              <th className='text-center '>{`${comunidad.selected.emisor_direccion}, ${comunidad.selected.emisor_comuna}`}</th>
              <td className='text-center text-primary text-small'>S.I.I. SANTIAGO CENTRO</td>
            </tr>
          </tbody>
        </Table>
        <Row className='border bg-light m-0 mb-1 p-1'>
          <Col xs={12} md={7} className='p-0'>
            <Table size='sm' responsive borderless className='text-small m-0 NotaCobro-datos-padding'>
              <tbody>
                <tr>
                  <th className='text-end column-ancho'>Código servicio:</th>
                  <td>{pintaNumero(notacobro.cabecera.codigo_servicio)}</td>
                </tr>
                <tr>
                  <th className='text-end column-ancho'>Periodo:</th>
                  <td>{notacobro.cabecera.periodo}</td>
                </tr>
                <tr>
                  <th className='text-end column-ancho'>Cliente:</th>
                  <td>{notacobro.cabecera.nombre_cliente}</td>
                </tr>
                <tr>
                  <th className='text-end column-ancho'>RUT:</th>
                  <td>{notacobro.cabecera.rut_cliente}</td>
                </tr>
                <tr>
                  <th className='text-end column-ancho'>Direccion:</th>
                  <td>{notacobro.cabecera.direccion_cliente}</td>
                </tr>
                <tr>
                  <th className='text-end column-ancho'>Ciudad:</th>
                  <td>{notacobro.cabecera.ciudad_cliente}</td>
                </tr>
                <tr>
                  <th className='text-end column-ancho'>Comuna:</th>
                  <td>{notacobro.cabecera.comuna_cliente}</td>
                </tr>
                <tr>
                  <th className='text-end column-ancho'>Medidor:</th>
                  <td>{notacobro.cabecera.medidor_id}</td>
                </tr>
              </tbody>
            </Table>
          </Col>
          <Col xs={12} md={5} className='p-0'>
            <Table size='sm' responsive borderless className='text-small m-0 NotaCobro-datos-padding'>
              <tbody>
                <tr>
                  <th className='text-end column-ancho'>Fecha Emisión:</th>
                  <td>{pintaFecha(notacobro.cabecera.fecha_emision)}</td>
                </tr>
                <tr>
                  <th className='text-end column-ancho'>Fecha Vencimiento:</th>
                  <td>{pintaFecha(notacobro.cabecera.fecha_vencimiento)}</td>
                </tr>
                <tr>
                  <th className='text-end column-ancho'>Fecha Inicio Lectura:</th>
                  <td>{pintaFecha(notacobro.cabecera.fecha_inicio_lectura)}</td>
                </tr>
                <tr>
                  <th className='text-end column-ancho'>Fecha Fin Lectura:</th>
                  <td>{pintaFecha(notacobro.cabecera.fecha_fin_lectura)}</td>
                </tr>
                <tr>
                  <th className='text-end column-ancho'>Lectura anterior:</th>
                  <td>{pintaNumero(notacobro.cabecera.lectura_anterior)} [kWh]</td>
                </tr>
                <tr>
                  <th className='text-end column-ancho'>Lectura periodo:</th>
                  <td>{pintaNumero(notacobro.cabecera.lectura_actual)} [kWh]</td>
                </tr>
                <tr>
                  <th className='text-end column-ancho'>Consumo periodo:</th>
                  <td>{pintaNumero(notacobro.cabecera.consumo)} [kWh]</td>
                </tr>
                <tr>
                  <th className='text-end column-ancho'>Estado:</th>
                  <td>{pintaEstado(notacobro.cabecera.estado)}</td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
        <Table size='sm' responsive className='text-small mb-1'>
          <thead>
            <tr className='text-muted'>
              <th className='text-center'>Descripcion del cargo</th>
              <th className='text-center'>Valor</th>
            </tr>
          </thead>
          <tbody>
            {notacobro.cargos.map((cargo) => (
              <tr key={cargo.nombre_cargo}>
                <td>{cargo.nombre_cargo}</td>
                <td className='text-end'>{pintaPesos(parseInt(cargo.monto_total))}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Table size='sm' responsive borderless className='text-small mb-0'>
          <tbody className='text-end'>
            <tr>
              <td rowSpan='6' className='text-center align-bottom'>
                <a style={{ display: 'table-cell' }} href={notacobro.cabecera.link_pdf} target='_blank' rel='noopener noreferrer'>
                  <PictureAsPdfIcon className='m-1' />
                  Ver NotaCobro
                </a>
              </td>
              <th>Saldo anterior:</th>
              <td className='column-totales'>{pintaPesos(notacobro.cabecera.saldo_mes_anterior)}</td>
            </tr>
            <tr className='text-primary'>
              <th>Total a pagar:</th>
              <th className='column-totales text-nowrap'>{pintaPesos(notacobro.cabecera.monto_total)}</th>
            </tr>
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}

export default NotaCobro;
